// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pAyr2M {
  display: flex;
  flex-direction: column;
  width: 220px;
  padding: var(--spacing-1);
  background-color: var(--background-white);
  border: 1px solid var(--surface-neutral-soft);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  z-index: 1000;
}

.wSAuMi {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1);
  border-radius: var(--radius-s);
  border: none;
  background: transparent;
  cursor: pointer;
  transition: var(--transition-normal);
  text-align: left;
  width: 100%;
}

.wSAuMi:focus {
  outline: 2px solid var(--brand-tr-orange);
  outline-offset: -2px;
}

.KzL6Kh {
  width: 12px;
  height: 12px;
  color: var(--brand-tr-orange);
  flex-shrink: 0;
}

.mPxeRF {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: left;
  flex: 1;
}

.ZYXPx8 {
  color: var(--status-error);
}

.HmVgd1 {
  color: var(--status-error);
}

/* Focus states for accessibility */
.wSAuMi:focus-visible {
  outline: 2px solid var(--brand-tr-orange);
  outline-offset: -2px;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .pAyr2M {
    border-color: var(--stroke-neutral-dark);
  }

  .KzL6Kh {
    color: var(--text-neutral-dark);
  }

  .mPxeRF {
    color: var(--text-neutral-dark);
  }

  .ZYXPx8,
  .HmVgd1 {
    color: var(--text-neutral-dark);
  }
}

/* Disabled state for cancel button */
.vueyl_ {
  cursor: not-allowed;
  opacity: 0.6;
}

.vueyl_ .KzL6Kh {
  color: var(--text-neutral-silver);
}

.vueyl_ .mPxeRF {
  color: var(--text-neutral-silver);
}

.vueyl_ .ZYXPx8 {
  color: var(--text-neutral-silver);
}

.vueyl_ .HmVgd1 {
  color: var(--text-neutral-silver);
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .wSAuMi {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesActionMenu/ChargesActionMenu.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;EACzC,6CAA6C;EAC7C,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,+BAA+B;EACjC;AACF;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".menu {\n  display: flex;\n  flex-direction: column;\n  width: 220px;\n  padding: var(--spacing-1);\n  background-color: var(--background-white);\n  border: 1px solid var(--surface-neutral-soft);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  z-index: 1000;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1);\n  border-radius: var(--radius-s);\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  text-align: left;\n  width: 100%;\n}\n\n.menuItem:focus {\n  outline: 2px solid var(--brand-tr-orange);\n  outline-offset: -2px;\n}\n\n.icon {\n  width: 12px;\n  height: 12px;\n  color: var(--brand-tr-orange);\n  flex-shrink: 0;\n}\n\n.text {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: left;\n  flex: 1;\n}\n\n.destructiveIcon {\n  color: var(--status-error);\n}\n\n.destructiveText {\n  color: var(--status-error);\n}\n\n/* Focus states for accessibility */\n.menuItem:focus-visible {\n  outline: 2px solid var(--brand-tr-orange);\n  outline-offset: -2px;\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .menu {\n    border-color: var(--stroke-neutral-dark);\n  }\n\n  .icon {\n    color: var(--text-neutral-dark);\n  }\n\n  .text {\n    color: var(--text-neutral-dark);\n  }\n\n  .destructiveIcon,\n  .destructiveText {\n    color: var(--text-neutral-dark);\n  }\n}\n\n/* Disabled state for cancel button */\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.disabled .icon {\n  color: var(--text-neutral-silver);\n}\n\n.disabled .text {\n  color: var(--text-neutral-silver);\n}\n\n.disabled .destructiveIcon {\n  color: var(--text-neutral-silver);\n}\n\n.disabled .destructiveText {\n  color: var(--text-neutral-silver);\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .menuItem {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `pAyr2M`,
	"menuItem": `wSAuMi`,
	"icon": `KzL6Kh`,
	"text": `mPxeRF`,
	"destructiveIcon": `ZYXPx8`,
	"destructiveText": `HmVgd1`,
	"disabled": `vueyl_`
};
module.exports = ___CSS_LOADER_EXPORT___;
